import React from 'react';
import {
  type FieldValues,
  useController,
  type UseControllerProps,
} from 'react-hook-form';
import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';
import type {TextareaProps} from '@spaced-out/ui-design-system/lib/components/Textarea/Textarea';


type IFormInputProps<T extends FieldValues> = UseControllerProps<T> &
  TextareaProps;

export const TextareaInput = <T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  disabled,
  ...otherProps
}: IFormInputProps<T>) => {
  const {field, fieldState} = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
    disabled,
  });
  return (
    <Textarea
      {...field}
      {...otherProps}
      error={Boolean(fieldState.error)}
      errorText={fieldState.error?.message}
    />
  );
};
